document.addEventListener('DOMContentLoaded', function () {
    const track = document.querySelector('.carousel-track');
    let startX = 0;
    let scrollLeft = 0;

    if (track) {
        track.addEventListener('mousedown', (e) => {
            e.preventDefault();
            startX = e.pageX - track.offsetLeft;
            scrollLeft = track.scrollLeft;

            track.classList.add('active');
        });

        track.addEventListener('mousemove', (e) => {
            if (!track.classList.contains('active')) return;
            const x = e.pageX - track.offsetLeft;
            const walk = (x - startX) * 2;
            track.scrollLeft = scrollLeft - walk;
        });

        track.addEventListener('mouseup', () => track.classList.remove('active'));
        track.addEventListener('mouseleave', () => track.classList.remove('active'));
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const searchButton = document.getElementById('search-button');
    const searchBar = document.getElementById('search-bar');

    searchButton.addEventListener('click', function () {
        // Cambia el valor de aria-expanded a true
        searchButton.setAttribute('aria-expanded', 'true');

        // Remueve la clase 'close' y agrega la clase 'open'
        searchBar.classList.remove('close');
        searchBar.classList.add('open');
    });
});